<section>
    <div class="title">
        <h2 class="unl-plan-type" [ngClass]="{ 'plan-seven-unl-plan-type': showPlanUpgradeBanner }">{{ showPlanNameHeader() | lowercase }}</h2>
    </div>
    <xm-switch-banner
        *ngIf="showPlanUpgradeBanner"
        [imageOptions]="circleDeviceIcon"
        [header]="seg5BtgToUnlSwitchBanner.header"
        [description]="seg5BtgToUnlSwitchBanner.description">
    </xm-switch-banner>
    <xm-switch-banner
        *ngIf="showSegmentUpgradeBanner && segmentSwitchBanner"
        [imageOptions]="segmentSwitchIcon"
        [header]="segmentSwitchBanner?.header"
        [description]="segmentSwitchBanner?.body"
        [cta]="segmentSwitchBanner?.cta">
    </xm-switch-banner>
    <div class="content">
        <div class="promotion-container" *ngIf="lineSummary?.isUnlPlus && user?.account?.isSegmentFour && !isIcopPlanSwitch">
            <div class="plan-promo">
                <xm-media-image [imageOptions]="promoIcon" class="promotion-dollar-icon"></xm-media-image>
                <div class="plan-desc">
                    <p>{{ plusUpgradeDowngrade.benefitHeader }}</p>
                    <div>
                        <span class="promo-desc">{{ plusUpgradeDowngrade.benefitDesc }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="header">{{ pageData.header }}</div>
        <div class="description">{{ pageData.description }}</div>
        <div class="promotion-container" *ngIf="promotionData.length > 0 && !isIcopPlanSwitch">
            <div class="multiple-promotions">
                <xm-media-image [imageOptions]="promoIcon" class="promotion-dollar-icon"></xm-media-image>
                <div>
                    <p>{{promotionHeader}}</p>
                    <ul class="promotions-list">
                        <li class="promotions-desc" *ngFor="let data of promotionData">{{ data }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <xm-icop-plan-switch-promotions *ngIf="isIcopPlanSwitch"></xm-icop-plan-switch-promotions>
        <div class="plan-tiers">
            <xm-unlimited-tier-selector *ngFor="let tier of tierData" [unlimitedTierPlan]="tier"
                [tierPrice]="showPrice(tier)" [showInUseBadge]="showInUseBadge(tier)"
                [showScheduledBadge]="showScheduledBadge(tier)" [priceSymbol]="showPriceSymbol(tier)"
                (emitPlanCode)="onEmitPlanCode($event)"></xm-unlimited-tier-selector>
        </div>
        <div *ngIf="pageData.disclaimer" class="disclaimer">
            <span>{{ pageData.disclaimer }}</span>
        </div>
    </div>
    <div class="buttons">
        <button class="xm-btn-link-light cancel" (click)="onCancel()">{{ pageData.cancelCta }}</button>
        <button class="xm-btn-primary-light" [disabled]="!isButtonEnabled" [ngClass]="{ 'disabled': !isButtonEnabled }"
            (click)="navToSwitchInProgress()">{{ buttonText }}</button>
    </div>
</section>